import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  GlobalNavBar,
  Logo,
  LinksWrapper,
  Link,
  LinkContainer,
  NavIcon,
  Hamburger,
  Row,
  Notifications,
  LogoWrapper,
} from './GlobalNav.styles.js';
import Cookies from 'js-cookie';
import { useHistory, useLocation } from 'react-router-dom';
import { GlobalContext } from 'components/context/GlobalContext';
import NavigationLink from 'components/_common/navigation-link';

import kvernelandGroupImg from 'components/global-nav/logos/Kverneland.jpg';
import kubotaImg from 'components/global-nav/logos/Kubota.png';
import viconImg from 'components/global-nav/logos/Vicon.jpg';
import HoverStyle from 'components/_common/navigation-link/HoverStyle.js';
import { Auth } from 'components/context/AuthContext.js';
import { HeaderLink, UserLink } from 'components/_common/navigation-link/NavigationLink.styles.js';

const GlobalNav = ({ links: { links: { links } = {}, MyProfile } = {}, logo, brand, favicon }) => {
  const { globalDispatch } = useContext(GlobalContext);
  const { userToken } = useContext(Auth);
  const [activeUser, setActiveUser] = useState(null);
  const history = useHistory();
  const location = useLocation();
  const returnLogo = brand => {
    let brandLogo = logo?.Logos.filter(item => item.brand === brand)[0]
      ? logo?.Logos.filter(item => item.brand === brand)[0]?.image.src
      : logo?.Logos.filter(item => item.brand === 'Kverneland Group')[0]?.image.src;
    return brandLogo;
  };

  const returnFavicon = brand => {
    let icon = favicon?.Icons.filter(item => item.Brand === brand)[0]
      ? favicon?.Icons.filter(item => item.Brand === brand)[0]?.Image.src
      : favicon?.Icons.filter(item => item.Brand === 'Kverneland Group')[0]?.Image.src;
    return icon;
  };

  useEffect(() => {
    if (document.getElementById('favicon')) {
      let newFavicon = document.getElementById('favicon');
      newFavicon.href = returnFavicon(brand);
    }
    setActiveUser(Cookies.get('ActivUserName'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

 const changeDealerHandler=()=>{
  // Cookies.set("IsFirstLogin",false)
  history.push('/multiple-contact')
  }

  return (
    <GlobalNavBar>
      {userToken && (
        <Hamburger
          onClick={() => {
            globalDispatch({
              type: 'SHOW_SIDEBAR',
            });
            globalDispatch({
              type: 'TOGGLE_SIDEBAR',
            });
          }}
        >
          <Row />
          <Row />
          <Row />
        </Hamburger>
      )}
      <LogoWrapper>
        <NavigationLink
          linkHref={Cookies.get('dashboard')}
          target={logo?.target}
          isExternal={logo?.isExternal}
        >
          <Logo src={returnLogo(brand)} alt={logo?.image?.alt} />
        </NavigationLink>
      </LogoWrapper>
      <LinksWrapper>
         {userToken && activeUser && location.pathname !== '/multiple-contact' && (
          <HeaderLink id="userName">{activeUser}</HeaderLink>
        )}
        
        {userToken && location.pathname !== '/multiple-contact' && Cookies.get('ActivUserContactsCount') > 1 && (
          <HeaderLink onClick={changeDealerHandler}>Change Dealer</HeaderLink>
          // <HeaderLink onClick={() => history.push('/multiple-contact')}>Change Dealer</HeaderLink>
        )}
        <HoverStyle links={links} MyProfile={MyProfile} />
      </LinksWrapper>
      {userToken && <Notifications name="notifications" />}
    </GlobalNavBar>
  );
};

GlobalNav.propTypes = {
  links: PropTypes.shape({
    links: PropTypes.array,
  }),
  logo: PropTypes.shape({
    image: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    }),
  }),
};

export default GlobalNav;
